import { useContext } from 'react';
import SettingsContext from '@/components/Settings/SettingsContext';

function useSettings() {
  return useContext(SettingsContext);
}

export default useSettings;
